<!--
  Layar pemeliharaan — menggantikan seluruh aplikasi selama BE dalam mode maintenance.

  Memeriksa BE tiap 30 detik lewat endpoint publik GET /banks. Hanya respons 2xx yang memuat
  ulang halaman: 503 berarti masih pemeliharaan, sedangkan 502/504 atau jaringan putus (BE
  sedang dihidupkan ulang) berarti belum siap — memuat ulang saat itu hanya membawa pengguna
  ke halaman yang gagal.
-->
<template>
  <div class="maintenance" role="alert">
    <div class="maintenance__isi">
      <img class="maintenance__logo" :src="require('@/assets/logo/RUMATKITA.webp')" alt="RUMATKITA" />

      <i class="material-icons maintenance__ikon" aria-hidden="true">build_circle</i>
      <h1 class="maintenance__judul">Sedang dalam pemeliharaan</h1>
      <p class="maintenance__teks">
        Kami sedang meningkatkan sistem RUMATKITA. Untuk sementara aplikasi belum bisa dipakai. Mohon coba lagi beberapa saat
        lagi.
      </p>
      <p class="maintenance__catatan">Halaman ini akan terbuka sendiri begitu layanan kembali normal.</p>

      <button type="button" class="maintenance__aksi" @click="muatUlang">Coba lagi</button>
    </div>
  </div>
</template>

<script>
const JEDA_PERIKSA_MS = 30000;

export default {
  name: "MaintenanceScreen",
  data() {
    return { pewaktu: null };
  },
  mounted() {
    this.pewaktu = setInterval(this.periksa, JEDA_PERIKSA_MS);
  },
  beforeUnmount() {
    clearInterval(this.pewaktu);
  },
  methods: {
    async periksa() {
      try {
        const respons = await fetch(`${process.env.VUE_APP_GATEWAY}banks`, { cache: "no-store" });
        if (respons.ok) this.muatUlang();
      } catch (e) {
        // Jaringan putus / BE belum hidup — tetap di layar ini, periksa lagi nanti.
      }
    },
    muatUlang() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.maintenance {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  justify-content: center;
  background-color: rgb(244, 244, 244);
}

.maintenance__isi {
  width: 100%;
  max-width: 480px;
  min-height: 100%;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #fff;
}

.maintenance__logo {
  width: 160px;
  object-fit: contain;
  margin-bottom: 32px;
}

.maintenance__ikon {
  font-size: 64px;
  color: #ed0000;
  margin-bottom: 8px;
}

.maintenance__judul {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
}

.maintenance__teks {
  font-size: 14px;
  margin-bottom: 8px;
}

.maintenance__catatan {
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 24px;
}

.maintenance__aksi {
  border: 0;
  border-radius: 10px;
  padding: 10px 28px;
  background: #ed0000;
  color: #fff;
  font-weight: 600;
}
</style>
